module.exports = __webpack_public_path__ + "img/icon_5_16.59bad8ac.png";